import { Markdown, type ITextProps } from '@kognitos/lattice';

import { ClampedText } from '@/shared/components/ClampedText';

interface IManifestClampedTextProps {
  text: string;
  textProps?: Pick<ITextProps, 'level' | 'color' | 'weight'>;
}

/** Renders prose (manifest/step overview) clamped to 3 lines, with a
 *  "Show more"/"Show less" toggle so long docstring overviews don't dominate
 *  the card. Clamps visually rather than slicing the raw string, which can land
 *  mid-markdown-syntax (e.g. mid-`**bold**` or mid-link) and render broken
 *  output. Keyed on `text` because the SOP view swaps the draft manifest for a
 *  focused test run's without remounting. */
export function ManifestClampedText({
  text,
  textProps,
}: IManifestClampedTextProps) {
  return (
    <ClampedText contentKey={text}>
      <Markdown textProps={textProps}>{text}</Markdown>
    </ClampedText>
  );
}
